
import { RevCheckbox } from '@ds/components/Checkbox'
import { RevInputText } from '@ds/components/InputText'
import { RevRadio } from '@ds/components/Radio'
import { RevTag } from '@ds/components/Tag'
import { IconSearch } from '@ds/icons/IconSearch'
import isEmpty from 'lodash/isEmpty'

import { searchObjects } from '@core/helpers/SearchObjects'
import { tw } from '@core/tailwind'

import translations from './FacetsFilters.translations'
import {
  CHECKBOX,
  INPUT_VARIANT,
  MAX_DISPLAYED_FACET_VALUES,
  RADIO,
} from './constants'

export default {
  components: {
    RevInputText,
    RevTag,
  },
  props: {
    facet: {
      type: Object,
      required: true,
    },
    facetFiltered: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      valueFilter: '',
      name: this.facet.facetName,
      title: this.facet.title,
      type: this.facet.type,
    }
  },
  computed: {
    translations: () => translations,
    IconSearch: () => IconSearch,
    isHigherThanMaxFacet() {
      return this.facet.facetValues.length > MAX_DISPLAYED_FACET_VALUES
    },
    values() {
      return this.facetsValuesWithCount.map((facet) => ({
        ...facet,
        checked: this.facetFiltered.includes(facet.facet_value),
      }))
    },

    facetClassNames() {
      if (this.isHigherThanMaxFacet) {
        return tw`max-h-[248px] overflow-y-auto`
      }

      return ''
    },

    facetContainerClassNames() {
      if (this.isHigherThanMaxFacet) {
        return 'facetFilterContainer'
      }

      return ''
    },

    facetId() {
      return `facet-filter-${this.facet.facetName}`
    },

    facetsValuesWithCount() {
      return this.facet.facetValues.filter(({ count }) => count)
    },

    showSearchInput() {
      return this.isHigherThanMaxFacet
    },

    displayedFacetValues() {
      const facets = searchObjects(this.values, 'label', this.valueFilter).map(
        (facet) => ({
          ...facet,
          props: {
            id: `${this.facet.facetName}-${facet.facet_value}`,
            variant: INPUT_VARIANT,
            disabled: this.disabled,
            checked: facet.checked,
            ...(this.type === RADIO && { value: facet.facet_value }),
          },
        }),
      )

      return facets
    },
    hasNoFilterChecked() {
      return !this.values.some((v) => v.checked)
    },
    resetFilterProps() {
      return {
        id: `${this.facet.facetName}-reset`,
        variant: INPUT_VARIANT,
        disabled: this.hasNoFilterChecked,
        checked: this.hasNoFilterChecked,
        ...(this.type === RADIO && { value: this.productFiltersNone }),
      }
    },
    facetTypeComponent() {
      return this.type === CHECKBOX ? RevCheckbox : RevRadio
    },
    productFiltersNone() {
      return this.$t(translations.productFilterNone)
    },
  },
  methods: {
    resetFacets() {
      this.$emit('change', null)
    },
    emitFacets({ value, isActive }) {
      let filters

      if (this.type === RADIO) {
        if (isActive) {
          filters = [value]
        } else {
          filters = []
        }
      }

      if (this.type === CHECKBOX) {
        if (isActive) {
          filters = [...this.facetFiltered, value]
        } else {
          filters = this.facetFiltered.filter((facet) => facet !== value)
        }
      }

      const payloadChange = isEmpty(filters) ? null : filters

      this.$emit('change', payloadChange)
    },
  },
}
